{
  "vitalsEntry": {
    "title": "Tanda Vital",
    "subtitle": "Catat dan tinjau tanda vital",
    "printLabel": "Cetak Tanda Vital",
    "recordSection": "Catat Tanda Vital",
    "save": "Catat Tanda Vital",
    "cancel": "Batal",
    "saving": "Mencatat...",
    "recordedSuccess": "Tanda vital berhasil dicatat",
    "recordedError": "Gagal mencatat tanda vital",
    "invalidEncounter": "ID kunjungan tidak valid.",
    "historyTitle": "Tanda Vital Terbaru",
    "loadingHistory": "Memuat tanda vital...",
    "loadError": "Gagal memuat tanda vital.",
    "emptyHistory": "Belum ada tanda vital yang dicatat untuk kunjungan ini.",
    "morseTitle": "Skala Risiko Jatuh Morse",
    "bradenTitle": "Skala Risiko Luka Tekan Braden",
    "riskScalesSaved": "Skor risiko berhasil dicatat",
    "riskScalesFailed": "Tanda vital tersimpan, tetapi skor risiko gagal dicatat"
  },
  "vitals": {
    "systolic": "Tekanan Darah Sistolik",
    "diastolic": "Tekanan Darah Diastolik",
    "heartRate": "Denyut Jantung",
    "respiratoryRate": "Frekuensi Pernapasan",
    "temperature": "Suhu",
    "oxygenSaturation": "Saturasi Oksigen (SpO2)",
    "oxygenSaturationShort": "SpO2",
    "painScore": "Skor Nyeri",
    "weight": "Berat Badan",
    "height": "Tinggi Badan",
    "bmi": "BMI",
    "rangeError": "{{field}} harus antara {{min}} dan {{max}}",
    "placeholders": {
      "temperature": "mis. 37,0",
      "heartRate": "mis. 72",
      "respiratoryRate": "mis. 16",
      "oxygenSaturation": "mis. 98",
      "systolic": "mis. 120",
      "diastolic": "mis. 80",
      "weight": "mis. 70,5",
      "height": "mis. 175",
      "painScore": "0-10"
    }
  },
  "vitalsRange": {
    "normal": "Normal",
    "borderline": "Batas",
    "abnormal": "Abnormal",
    "critical": "Kritis"
  },
  "tableHeaders": {
    "dateTime": "Tanggal/Waktu",
    "temperature": "Suhu",
    "heartRate": "Nadi",
    "respiratoryRate": "Napas",
    "bloodPressure": "Tekanan",
    "oxygenSaturation": "SpO2",
    "weight": "Berat",
    "height": "Tinggi",
    "pain": "Nyeri"
  },
  "io": {
    "title": "Asupan & Keluaran",
    "addRecord": "Tambah Catatan",
    "addRecordSection": "Tambah Catatan I/O",
    "loading": "Memuat catatan I/O...",
    "loadError": "Gagal memuat catatan I/O.",
    "empty": "Belum ada catatan I/O untuk kunjungan ini.",
    "totals": {
      "intake": "Total Asupan",
      "output": "Total Keluaran",
      "balance": "Keseimbangan Bersih",
      "totalsRow": "Total",
      "netLabel": "Bersih"
    },
    "negativeWarning": "Keseimbangan negatif — tinjau status cairan",
    "columns": {
      "dateTime": "Tanggal/Waktu",
      "type": "Tipe",
      "category": "Kategori",
      "amount": "Jumlah (ml)",
      "notes": "Catatan"
    },
    "fields": {
      "type": "Tipe",
      "category": "Kategori",
      "amount": "Jumlah (ml)",
      "notes": "Catatan"
    },
    "type": {
      "intake": "Asupan",
      "output": "Keluaran"
    },
    "categoryPlaceholder": "Pilih kategori...",
    "amountPlaceholder": "0",
    "notesPlaceholder": "Catatan opsional...",
    "save": "Simpan Catatan",
    "cancel": "Batal",
    "missingValueShort": "--",
    "toast": {
      "added": "Catatan I/O ditambahkan",
      "addFailed": "Gagal menambahkan catatan I/O",
      "missingFields": "Mohon isi kolom wajib"
    }
  },
  "intake": {
    "oral": "Oral",
    "iv": "IV",
    "bloodProducts": "Produk Darah",
    "tpn": "TPN",
    "tubeFeeding": "Pemberian Selang",
    "other": "Lainnya"
  },
  "output": {
    "urine": "Urin",
    "drain": "Drain",
    "emesis": "Muntahan",
    "stool": "Tinja",
    "bloodLoss": "Kehilangan Darah",
    "ngSuction": "Suction NG",
    "other": "Lainnya"
  },
  "wound": {
    "title": "Dokumentasi Perawatan Luka",
    "subtitle": "Kunjungan #{{id}} — Penilaian luka terstruktur",
    "newAssessment": "Penilaian Luka Baru",
    "dimensionsTitle": "Dimensi (cm)",
    "woundBedTitle": "Dasar Luka (%)",
    "woundBedTotalWarning": "Total: {{total}}% (seharusnya 100%)",
    "woundBedTotalOk": "Total: 100%",
    "previousTitle": "Penilaian Sebelumnya",
    "empty": "Belum ada penilaian luka untuk kunjungan ini.",
    "invalidEncounter": "ID kunjungan tidak valid.",
    "save": "Simpan Penilaian",
    "savedSuccess": "Penilaian luka tercatat",
    "savedError": "Gagal menyimpan penilaian luka",
    "fields": {
      "woundType": "Jenis Luka",
      "location": "Lokasi",
      "stage": "Stadium",
      "length": "Panjang",
      "width": "Lebar",
      "depth": "Kedalaman",
      "granulation": "Jaringan Granulasi",
      "slough": "Jaringan Slough",
      "eschar": "Eschar",
      "epithelial": "Jaringan Epitel",
      "drainageType": "Jenis Eksudat",
      "drainageAmount": "Jumlah Eksudat",
      "surroundingSkin": "Kulit Sekitar",
      "treatment": "Tindakan yang Diberikan",
      "painScore": "Skor Nyeri (0-10)",
      "notes": "Catatan"
    },
    "placeholders": {
      "length": "mis. 3,5",
      "width": "mis. 2,0",
      "depth": "mis. 0,5",
      "treatment": "Jelaskan tindakan perawatan luka yang diberikan...",
      "notes": "Pengamatan tambahan..."
    },
    "history": {
      "dimensionsLabel": "Dimensi",
      "drainageLabel": "Eksudat",
      "painLabel": "Nyeri",
      "treatmentLabel": "Tindakan"
    },
    "stage": {
      "stage1": "Stadium 1",
      "stage2": "Stadium 2",
      "stage3": "Stadium 3",
      "stage4": "Stadium 4",
      "unstageable": "Tidak Dapat Distadiumkan",
      "deepTissue": "Cedera Jaringan Dalam",
      "na": "N/A"
    },
    "drainageType": {
      "none": "Tidak Ada",
      "serous": "Serosa",
      "sanguineous": "Sanguineus",
      "serosanguineous": "Serosanguineus",
      "purulent": "Purulen"
    },
    "drainageAmount": {
      "none": "Tidak Ada",
      "scant": "Sangat Sedikit",
      "small": "Sedikit",
      "moderate": "Sedang",
      "large": "Banyak",
      "copious": "Sangat Banyak"
    },
    "woundType": {
      "pressure": "Cedera tekan",
      "surgical": "Bedah",
      "diabetic": "Ulkus diabetik",
      "venous": "Ulkus vena",
      "arterial": "Ulkus arteri",
      "traumatic": "Traumatis",
      "skinTear": "Robekan kulit",
      "other": "Lainnya"
    },
    "location": {
      "sacrum": "Sakrum",
      "coccyx": "Koksigis",
      "leftHeel": "Tumit kiri",
      "rightHeel": "Tumit kanan",
      "leftTrochanter": "Trokhanter kiri",
      "rightTrochanter": "Trokhanter kanan",
      "abdomen": "Abdomen",
      "leftLeg": "Kaki kiri",
      "rightLeg": "Kaki kanan",
      "back": "Punggung",
      "other": "Lainnya"
    },
    "surroundingSkin": {
      "intact": "Utuh",
      "erythema": "Eritema",
      "macerated": "Maserasi",
      "indurated": "Indurasi",
      "edematous": "Edema",
      "warm": "Hangat",
      "discolored": "Berubah warna"
    }
  },
  "carePlan": {
    "title": "Rencana Asuhan",
    "addPlan": "Tambah Rencana Asuhan",
    "newPlan": "Rencana Asuhan Baru",
    "createPlan": "Buat Rencana",
    "cancel": "Batal",
    "empty": "Belum ada rencana asuhan untuk pasien ini.",
    "emptyGoals": "Belum ada tujuan yang ditetapkan.",
    "goals": "Tujuan",
    "addGoal": "Tambah Tujuan",
    "saving": "Menyimpan...",
    "loading": "Memuat rencana asuhan...",
    "loadError": "Gagal memuat rencana asuhan.",
    "fields": {
      "title": "Judul",
      "startDate": "Tanggal Mulai",
      "targetDate": "Tanggal Target",
      "description": "Deskripsi",
      "target": "Target"
    },
    "placeholders": {
      "title": "mis. Rencana Pencegahan Jatuh",
      "description": "Deskripsi tujuan",
      "target": "mis. Tidak jatuh dalam 30 hari"
    },
    "history": {
      "startLabel": "Mulai",
      "targetLabel": "Target",
      "goalsLabel": "Tujuan"
    },
    "status": {
      "active": "Aktif",
      "completed": "Selesai",
      "cancelled": "Dibatalkan"
    },
    "goalStatus": {
      "inProgress": "Sedang Berjalan",
      "achieved": "Tercapai",
      "notAchieved": "Belum Tercapai"
    },
    "toast": {
      "planCreated": "Rencana asuhan dibuat",
      "planCreateFailed": "Gagal membuat rencana asuhan",
      "goalAdded": "Tujuan ditambahkan",
      "goalAddFailed": "Gagal menambahkan tujuan",
      "planValidation": "Judul dan tanggal mulai wajib diisi",
      "goalValidation": "Deskripsi dan target wajib diisi"
    }
  }
}
